import axios from 'axios';
import callMe from './callApi';
async function fetchBookNo(obj){
    var { value, bookno, start, callingFrom } = obj;
    var response = {};
    if(start){
        if(bookno.includes(value)){
            console.log('match');
            console.log(bookno);    
            return;
        }
        else{
            console.log('no match');
            bookno.push(value);    
            console.log('calling sort api against book no '+value);  
            var createdAt = sessionStorage.getItem('at')
            var api = (callingFrom === "dispatch")?'getSortBookDetailsForDispatch?bookNumber='+value+'&createdAt='+createdAt:'getSortBookDetails?bookNumber='+ value
            return callMe(value, callingFrom,api).then(tableData =>{
                if(Object.keys(tableData).length > 0 && tableData.success === true){
                    response.data = tableData;
                    response.error = false;
                    response.apiResponse  = tableData.apiresponse
                }
                else{
                    if(!tableData.success){
                        bookno.pop(value);
                        response.data= tableData.errorDesc;
                        response.error = true;
                    }
                }
                response.bookno = bookno;
                return response;
            })
            .catch(err =>{
                console.log(err);
            });
        }
    }
}

export default fetchBookNo;


// WEBPACK FOOTER //
// ./src/Components/fetchCode.js